import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import config from "@/config/app";

// Modules
import auth from "./modules/auth";
import user from "./modules/user";
import pond from "./components/pond";
import shrimptalk from "./modules/shrimptalk";
import superadmin from "./modules/superadmin";
import dealer from "./modules/dealer";
import header from "./components/header";
import accountManager from "./modules/accountManager";
Vue.use(Vuex);
const debug = process.env.NODE_ENV !== "production";
const store = new Vuex.Store({
  modules: {
    auth,
    user,
    pond,
    shrimptalk,
    superadmin,
    header,
    dealer,
    accountManager,
  },
  strict: debug,
  plugins: [
    createPersistedState({
      key: config.APP_VERSION,
      paths: [
        "auth",
        "user.currUserLocation",
        "user.userLocations",
        "user.user",
      ],
      // setState: (key, state, storage) => {
      //   try {
      //     return storage.setItem(
      //       `user_${state.user.user._id}`,
      //       JSON.stringify(state)
      //     );
      //   } catch (err) {
      //     return storage.clear();
      //   }
      // }
    }),
  ],
});

export default store;
